<br>
<!--div *ngIf="!showMailView" class="form-row btntop col-sm-12" style="margin-top: 10px;">
  <table>
    <tr>
      <td>
        <button class="btn border" (click)="search()" [disabled]="!form.valid">Sök</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="clear()">Rensa</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="expanded = !expanded;expandedlabel==='Stäng grupper'? expandedlabel='Öppna grupper' : expandedlabel='Stäng grupper'">{{expandedlabel}}</button>
      </td>
    </tr>
  </table>
  <p class="reportlabel">Rapport: Gottstående 2</p>
</div-->
<div
  *ngIf="!showMailView"
  class="ms-3 d-flex justify-content-start mt-2 mb-2"
>
  <div class="d-flex" style="gap: 1rem">
    <button class="btn border" (click)="search()">Sök</button>
    <button class="btn border" (click)="clear()">Rensa</button>
    <button
      class="btn border"
      (click)="
        expanded = !expanded;
        expandedlabel === 'Stäng grupper'
          ? (expandedlabel = 'Öppna grupper')
          : (expandedlabel = 'Stäng grupper')
      "
    >
      {{ expandedlabel }}
    </button>
    <div class="reportlabel">
      Rapport: Gottstående 2<i
        *ngIf="showSpinner"
        class="fa fa-spinner fa-spin"
        style="font-size: 22px; color: #920000; margin-left: 30px"
      ></i>
    </div>
  </div>
</div>


<form *ngIf="!showMailView" [formGroup]="form" (keydown.enter)="search()">
  <div class="col-xs-11 col-md-11 col-xl-11 ms-4 me-4">

    <div class="row">
      <div class="col-md-6">
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Ämbete
            </mat-panel-title>     
          </mat-expansion-panel-header>
          <div class="d-flex justify-space-between gap-2">
            <div class="form-group">
              <label for="officeTypeId">
                Ämbetstyp
              </label>
              <select class="form-control form-control-sm" id="officeTypeId" formControlName="officeTypeId" (change)="getOfficesByOfficeType($event)">
                <option></option>
                <option *ngFor="let ot of officetypelist" [value]="ot.id">{{ot.name}}</option>
              </select>
            </div>

            <div class="form-group">
              <label for="officeId">
                Ämbete <span *ngIf="!form.valid || !form.get('officeId').value" style="color:red;">(obligatoriskt)</span>
              </label>
              <p-select formControlName="officeId" [options]="officelist" filter="true" [showClear]="true" optionLabel="officeName" [style]="{'width':'100%','height': '31px'}" (onChange)="getCommitteesByOfficeId($event)" appendTo="body"></p-select>
            </div>
          </div>


          
            <div class="form-group w-50">
              <label for="committeeId">
                Utskott
              </label>
              <select class="form-control form-control-sm" id="committeeId" formControlName="committeeId">
                <option></option>
                <option *ngFor="let c of committeelist" [value]="c.id">{{c.name}} &nbsp;({{c.abbreviation}}) </option>
              </select>
            </div>
          

          <br>
          <div class="row">
            <div class="col-md-6">
              I någon av institutionerna:

              <button class="btn-small btn-primary" style="width:30px;margin-left:4px;" title="Välj institutioner"
                      (click)="displayOfficeInstitutions=true;">
                <i class="fa fa-plus"></i>
              </button>
              <button class="btn-small btn-primary" style="width:30px;margin-left:4px;" title="Rensa valda institutioner"
                      (click)="selectedofficeinstitutions=[]">
                <i class="fa fa-trash"></i>
              </button>

            </div>
            <div class="col-md-6">
              <table style="border:1px solid lightgrey;border-radius:3px;width:280px;">
                <tr *ngFor="let x of selectedofficeinstitutions">
                  <td>{{x.name}}</td>
                  <td align="right">
                    <i class="fa fa-times" (click)="removeSelectedOfficeInstitution(x.id)"
                       title="Ta bort vald institution"></i>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <br>
          <div class="row">
            <div class="col-md-6">

              Period började mellan<br>

              
                <div class="d-flex justify-content-start gap-2">

                  <app-calendarnotrequired [form]="form" formName="officeStartPeriodFrom"></app-calendarnotrequired>&nbsp;

                  <app-calendarnotrequired [form]="form" formName="officeStartPeriodTo"></app-calendarnotrequired>
                  <button class="btn btn-primary" (click)="setDate('officeStartPeriodTo', 'officeEndPeriodFrom')"
                          style="margin-left:10px;">
                    Just nu
                  </button>
                </div>
              
            </div>
            <div class="col-md-6">
              Period slutade mellan<br>
              <p-datepicker id="officeEndPeriodFrom" formControlName="officeEndPeriodFrom" appendTo="body" [showWeek]="true" [locale]="se"
                          [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true"
                          yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>&nbsp;
              <p-datepicker id="officeEndPeriodTo" formControlName="officeEndPeriodTo" appendTo="body" [showWeek]="true" [locale]="se"
                          [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true"
                          yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>

            </div>
          </div>

        </mat-expansion-panel>

        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Medlemsår
            </mat-panel-title>
          
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-md-12">
              <table>
                <tr>
                  <td>
                    <p-select [options]="years" formControlName="memberYear" appendTo="body" [filter]="false"
                                optionLabel="year" [style]="{'min-width':'110px', 'width':'110px'}">
                    </p-select>
                  </td>
                </tr>
              </table>
            </div>
            <br>
          </div>
        </mat-expansion-panel>
      </div>

      <div class="col-md-6">

        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Medlemskap
            </mat-panel-title>
         
          </mat-expansion-panel-header>
         

          <br>

Medlemskap i <span *ngIf="form.get('membershipSomeOrAll').errors?.nomembership" class="text-danger">(obligatoriskt)</span><br>
          <div class="d-flex justify-content-start align-items-center">
            <div>
              
              <p-selectButton [options]="someorall" formControlName="membershipSomeOrAll"></p-selectButton>
              </div>
              
              <div class="ms-2">
                <button *ngIf="form.get('membershipSomeOrAll').value" class="btn-small btn-primary"
                        (click)="displayMembershipInstitutions=true;">
                  <i class="fa fa-plus"></i>
                </button>
                <button *ngIf="form.get('membershipSomeOrAll').value" class="btn-small btn-primary"
                        title="Rensa valda institutioner" style="margin-left:4px;"
                        (click)="membershipselectedinstitutions=[]">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
          </div>

          <div class="row">
           
            <div class="col-md-5">
              <table style="border:1px solid lightgrey;border-radius:3px;width:280px;">
                <tr *ngFor="let x of membershipselectedinstitutions">
                  <td>{{x.name}}</td>
                  <td align="right">
                    <i class="fa fa-times" (click)="removeMembershipSelectedInstitution(x.id)"
                       title="Ta bort vald institution"></i>
                  </td>
                </tr>
              </table>

            </div>

          </div>
          <br>
          <br>
          <div class="row">
            <div class="col-md-6">

              Medlemskapet påbörjades mellan<br>
              <p-datepicker id="membershipStartedFrom" formControlName="membershipStartedFrom" appendTo="body"
                          [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}"
                          [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>&nbsp;
              <p-datepicker id="membershipStartedTo" formControlName="membershipStartedTo" appendTo="body" [showWeek]="true" [locale]="se"
                          [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true"
                          yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>
              <button class="btn btn-primary" (click)="setDate('membershipStartedTo', 'membershipEndedFrom')"
                      style="margin-left:10px;">
                Just nu
              </button>
            </div>

            <br>
            <div class="col-md-6">
              Medlemskapet avslutades mellan<br>
              <p-datepicker id="membershipEndedFrom" formControlName="membershipEndedFrom" appendTo="body" [showWeek]="true" [locale]="se"
                          [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true"
                          yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>&nbsp;
              <p-datepicker id="membershipEndedTo" formControlName="membershipEndedTo" appendTo="body" [showWeek]="true" [locale]="se"
                          [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true"
                          yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>
            </div>
          </div>
          <!-- Icke medlemskap i ....-->
          <hr />
          
            
             

        
          Icke medlemskap i <span *ngIf="form.get('nomembershipSomeOrAll').errors?.nomembership" class="text-danger">(obligatoriskt)</span><br>
          <div class="d-flex justify-content-start align-items-center">
            <div>
              
              <p-selectButton [options]="someorall" formControlName="nomembershipSomeOrAll"></p-selectButton>
              </div>
              
              <div class="ms-2">
                <button *ngIf="form.get('nomembershipSomeOrAll').value" class="btn-small btn-primary"
                        (click)="displayNoMembershipInstitutions=true;">
                  <i class="fa fa-plus"></i>
                </button>
                <button *ngIf="form.get('nomembershipSomeOrAll').value" class="btn-small btn-primary"
                        title="Rensa valda institutioner" style="margin-left:4px;"
                        (click)="nomembershipselectedinstitutions=[]">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
          </div>

          <div class="row">
           
            <div class="col-md-5">
              <table style="border:1px solid lightgrey;border-radius:3px;width:280px;">
                <tr *ngFor="let x of nomembershipselectedinstitutions">
                  <td>{{x.name}}</td>
                  <td align="right">
                    <i class="fa fa-times" (click)="removeNoMembershipSelectedInstitution(x.id)"
                       title="Ta bort vald institution"></i>
                  </td>
                </tr>
              </table>

            </div>

          </div>
          <br>
          <br>
          <div class="row">
            <div class="col-md-6">

              Medlemskapet påbörjades mellan<br>
              <p-datepicker id="nomembershipStartedFrom" formControlName="nomembershipStartedFrom" appendTo="body"
                          [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}"
                          [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>&nbsp;
              <p-datepicker id="nomembershipStartedTo" formControlName="nomembershipStartedTo" appendTo="body" [showWeek]="true" [locale]="se"
                          [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true"
                          yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>
              <button class="btn btn-primary" (click)="setDate('nomembershipStartedTo', 'nomembershipEndedFrom')"
                      style="margin-left:10px;">
                Just nu
              </button>
            </div>

            <br>
            <div class="col-md-6">
              Medlemskapet avslutades mellan<br>
              <p-datepicker id="nomembershipEndedFrom" formControlName="nomembershipEndedFrom" appendTo="body" [showWeek]="true" [locale]="se"
                          [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true"
                          yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>&nbsp;
              <p-datepicker id="nomembershipEndedTo" formControlName="nomembershipEndedTo" appendTo="body" [showWeek]="true" [locale]="se"
                          [showButtonBar]="true" [monthNavigator]="true" [inputStyle]="{'width':'110px'}" [yearNavigator]="true"
                          yearRange="1920:2030" dateFormat="yy-mm-dd"></p-datepicker>
            </div>
          </div>

        
        </mat-expansion-panel>

        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Välj rapport
            </mat-panel-title>
          
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-md-12">
              <mat-radio-group aria-label="Typ" formControlName="reportType" class="d-flex justify-content-start gap-2" required>
                <mat-radio-button value="all">Alla betalningar per medlem</mat-radio-button>
                <mat-radio-button value="notfullypaid">Ej fullbetalda medlemmar</mat-radio-button>
              </mat-radio-group>
            </div>
            <br>
          </div>
        </mat-expansion-panel>
      </div>

    </div>
  </div>
</form>

<div *ngIf="gsr.length > 0 && !showMailView" class="mx-2">

  <div class="resultdiv">

    <p-menubar [model]="items">
      <div class="d-flex justify-content-end mr-2">
        <div class="justify-content-between align-items-center mt-1">
          Resultat: {{gsr?.length}}
          <span class="ms-2">
            Välj alla:
            <mat-checkbox #checkAll (change)="checkuncheckAll(checkAll);"></mat-checkbox>
          </span>
        </div>
      </div>
    </p-menubar>
    <table matSort class="table table-bordered" (matSortChange)="sortData($event)" matSortDisableClear=true>
      <tr>
        <th mat-sort-header="memberId">Medlemsnr</th>
        <th mat-sort-header="givenname">Förnamn</th>
        <th mat-sort-header="familyname">Efternamn</th>
        <th mat-sort-header="fullypaid">Fullbetald</th>
        <th mat-sort-header="primaryLodge">Primärloge</th>

        <th>Årsavgift</th>
        <th>Betalt totalt</th>
        <th mat-sort-header="currentLodge">Aktuell loge</th>
        <th>Epost</th>
      </tr>

      <tr *ngFor="let result of gsr">
        <td>
          <a [routerLink]="['/memberform/id/', result.memberId]">
            {{result.memberId}}
          </a>
        </td>
        <td>{{result.givenName}}</td>
        <td>{{result.familyName}}</td>
        <td *ngIf="result.yearBalance >= 0" class="text-center">
          <i class="fa fa-check" aria-hidden="true" style="color:green;"></i>
        </td>
        <td *ngIf="result.yearBalance < 0" class="text-center">
          <i class="fa fa-times" aria-hidden="true" style="color:red;"></i>
        </td>
        <td>{{result.primaryLodge}}</td>
        <!--<td>{{result.year}}</td>-->
        <td>{{result.feeAfterDiscount}}</td>
        <td>{{result.payments}}</td>
        <td>{{result.currentLodge}}</td>

        <td>
          <div class="d-flex justify-content-between">
            <!--mat-checkbox *ngIf="result.checkbox" #inputEl (change)="add(result, inputEl);" [checked]="result.checked"></mat-checkbox><i *ngIf="result.email1 && result.checkbox" class="fa fa-envelope-o mt-1" aria-hidden="true"></i-->
            <mat-checkbox *ngIf="result.checkbox" #inputEl (change)="add(result, inputEl);" [checked]="result.checked"></mat-checkbox><i *ngIf="result.checkbox" class="fa fa-envelope-o mt-1" aria-hidden="true"></i>
          </div>
        </td>
      </tr>
    </table>
  </div>

</div>

<div *ngIf="showMailView">
  <app-mail [memberlist]=selectedmembers (closeEmail)="closeEmail($event)"></app-mail>
</div>

<p-dialog header="Medlemskap i" [(visible)]="displayMembershipInstitutions" [modal]="true" [style]="{width: '50vw'}"
          [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
  <app-institution-chooser [selectedinstitutions]="membershipselectedinstitutions" [form]="form"
                           (institutionSelected)="setSelectedInstitutions($event, 'membership')"></app-institution-chooser>
</p-dialog>

<p-dialog header="Välj institution" [(visible)]="displayOfficeInstitutions" [modal]="true" [style]="{width: '50vw'}"
          [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
  <app-institution-chooser [selectedinstitutions]="selectedofficeinstitutions" [form]="form"
                           (institutionSelected)="setSelectedInstitutions($event, 'office')"></app-institution-chooser>
</p-dialog>

<p-dialog header="Icke medlemskap i" [(visible)]="displayNoMembershipInstitutions" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
  <app-institution-chooser [selectedinstitutions]="nomembershipselectedinstitutions" [form]="form" (institutionSelected)="setSelectedNoInstitutions($event, 'nomembership')"></app-institution-chooser>
</p-dialog>

<!--pre>{{form.value|json}}</pre-->
